import { red } from "@material-ui/core/colors";

export default class AppColors {
    public static readonly PRIMARY_COLOR = "#1E2529";
    public static readonly PRIMARY_COLOR_WITH_ALPHA = "#1E2529E1";
    public static readonly HOME_BACKGROUND_COLOR = "#1E2529D0";
    public static readonly APP_BAR_BACKGROUND_COLOR = AppColors.PRIMARY_COLOR;
    public static readonly CYAN = "#00BCD4";
    public static readonly GREY_TEXT = "#b1b8c7";
    public static readonly WHITE = "#FFFFFF";
    public static readonly BLACK = "#111111";
    public static readonly BLUE = "#0c6cf2";
    public static readonly WHITE_SMOKE = "#F8F8F8";
    public static readonly ACCENT_COLOR = "#f28b24";
    public static readonly ACCENT_COLOR_ALPHA = "#f28b24e1";
    public static readonly EASE_GRAY = "#f7f7f7";
    public static readonly GREEN = "#4caf50";
    public static readonly RED = red[200];
    public static readonly GREEN_ALPHA = "#4caf50e1";
    public static readonly CARD_BACKGROUND_COLOR = AppColors.PRIMARY_COLOR;
    public static readonly CARD_BACKGROUND_COLOR_LIGHT = "#2E383E";
    public static readonly CARD_INPUT_FIELDS = "#3B4850";
    public static readonly CARD_SECTION_HEADER_COLORS = "#262F34";
    public static readonly CARD_INPUT_TEXT_COLORS = AppColors.GREY_TEXT;

    public static lightenOrDarken(color: string, percent: number): string {
        let usePound = false;
        if (color[0] === "#") {
            color = color.slice(1);
            usePound = true;
        }
        let num = parseInt(color, 16);
        let r = (num >> 16) + percent;
        if (r > 255) r = 255;
        else if (r < 0) r = 0;
        var b = ((num >> 8) & 0x00FF) + percent;
        if (b > 255) b = 255;
        else if (b < 0) b = 0
        var g = (num & 0x0000FF) + percent;
        if (g > 255) g = 255;
        else if (g < 0) g = 0;
        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }

}